const translations = {
  fr: {
    // SplashScreen
    splashTitle: 'Veuillez patienter…',
    splashLoading: 'Création du profil utilisateur…',

    // WindowHome
    homeTitle: 'OnlineCreation.exe',
    homeHeadline: 'Votre site web est digne de l\'an 2000 ?',
    homeDescription: 'vous accompagne dans le développement ou la refonte de vos projets web et mobile\u00a0:',
    homeWebsite: 'site web',
    homeMobileApp: 'application mobile iOS et Android',
    homeEcommerce: 'e-commerce',
    homeContact: 'Contacter',
    homeAbout: 'À propos',
    homePortfolio: 'Voir le portfolio',

    // WindowContact
    contactTitle: 'contact2000.exe',
    contactMessageSent: 'Message envoyé, merci.',
    contactIntro: 'Parlez-nous de votre projet !',
    contactFormLabel: 'Formulaire de contact',
    contactName: 'Nom',
    contactNamePlaceholder: 'Pierre Brochant',
    contactEmail: 'E-mail *',
    contactEmailPlaceholder: 'pierre.brochant@club-internet.fr',
    contactPhone: 'Tel.',
    contactPhonePlaceholder: '+33 5 35 54 05 04',
    contactSubject: 'Objet *',
    contactSubjectPlaceholder: 'Développement web',
    contactMessageDefault: 'Bonjour,',
    contactRequired: '* Champs obligatoires',
    contactCancel: 'Annuler',
    contactSend: 'Envoyer',
    contactConfirmQuit: 'Voulez-vous vraiment quitter ?',
    contactQuitWithout: 'Quitter sans envoyer',
    contactDontQuit: 'Ne pas quitter',
    contactAlertEmail: 'Veuillez saisir votre adresse e-mail.',
    contactAlertMessage: 'Veuillez saisir votre message (10 caractères minimum)',
    contactAlertSubject: 'Veuillez saisir un sujet.',
    contactAlertError: 'Une erreur est survenue, veuillez réessayer.',

    // WindowAbout
    aboutTitle: 'À propos d\'OnlineCreation',
    aboutDescription: 'OnlineCreation est l\'agence web basée à Bordeaux qui vous accompagnera pour tous vos projets de développements connectés.',
    aboutLocation: 'Localisation',
    aboutMapAlt: 'Basé à Bordeaux',
    aboutHQ: 'Siège social',
    aboutCapital: 'SARL au capital de 4\u00a0500\u00a0€',
    aboutSiret: 'SIRET',
    aboutTVA: 'Numéro de TVA',
    aboutDirector: 'Directeur de pub.',
    aboutHost: 'Hébergeur',
    aboutServices: 'Métiers',
    aboutServiceWeb: 'Création de <strong>sites web</strong>',
    aboutServiceShop: '<strong>Boutiques</strong> en ligne',
    aboutServiceApp: 'Conception d\'<strong>applications</strong>',
    aboutServiceDesign: 'Création <strong>graphique</strong> UI/UX web',
    aboutServiceMaintenance: '<strong>Maintenance</strong> de projets web',
    aboutTech: 'Technologies',
    aboutCredits: 'Crédits',
    aboutCreditsText: 'Site conçu avec',
    aboutClose: 'Fermer',
    aboutContactBtn: 'Contacter OnlineCreation',

    // WindowPortfolio
    portfolioTitle: 'realisations.exe',
    portfolioClient: 'Client',
    portfolioProject: 'Projet',
    portfolioClose: 'Fermer',
    portfolioContactBtn: 'Contacter OnlineCreation',

    // WindowSite
    sitePreview: 'Aperçu',
    siteVisit: 'Visiter le site',
    siteNeed: 'Besoin',
    siteSolution: 'Solution apportée par OnlineCreation',
    siteTech: 'Technologies',
    siteClose: 'Fermer',
    siteContactBtn: 'Contacter OnlineCreation',

    // WindowSettings
    settingsTitle: 'Paramètres',
    settingsWallpaper: 'Fond d\'écran',
    settingsWallpaperParticles: 'Particules (par défaut)',
    settingsWallpaperTeal: 'Couleur unie (Sarcelle)',
    settingsWallpaperPhoto: 'Photo (Paysage)',
    settingsPreview: 'Aperçu',
    settingsLanguage: 'Langue',
    settingsLangFr: 'Français',
    settingsLangEn: 'English',
    settingsApply: 'Appliquer',
    settingsClose: 'Fermer',

    // Taskbar
    taskbarClose: 'Fermer',

    // Desktop icons
    iconOnlineCreation: 'OnlineCreation.exe',
    iconContact: 'contact2000.exe',
    iconShop: 'boutique.exe',

    // WindowShop
    shopTitle: 'boutique.exe',
    shopLoading: 'Chargement du catalogue\u2026',
    shopError: 'Erreur lors du chargement du catalogue.',
    shopRetry: 'Réessayer',
    shopEmpty: 'Aucun résultat.',
    shopFilters: 'Filtres',
    shopColumns: 'Colonnes',
    shopBrand: 'Marque',
    shopModel: 'Modèle',
    shopScreen: 'Écran',
    shopRam: 'RAM',
    shopStorage: 'Stockage',
    shopGrade: 'Grade',
    shopColor: 'Couleur',
    shopCpu: 'CPU',
    shopBattery: 'Batterie',
    shopGpu: 'GPU',
    shopOs: 'Système',
    shopStock: 'Stock',
    shopInStock: 'En stock',
    shopPrice: 'Prix TTC',
    shopPriceHt: 'Prix HT',
    shopEcotax: 'dont éco-contribution',
    shopQuoteBtn: 'Demander un devis',
    shopFilterAll: 'Tous',
    shopNoSelection: 'Veuillez sélectionner au moins un article.',
    shopClose: 'Fermer',

    // WindowQuote
    quoteTitle: 'devis.exe',
    quoteIntro: 'Demandez un devis pour les articles sélectionnés.',
    quoteContactInfo: 'Informations de contact',
    quoteEmail: 'E-mail *',
    quoteEmailPlaceholder: 'votre@email.fr',
    quoteCountry: 'Pays *',
    quoteCountryPlaceholder: 'France',
    quoteShippingLabel: 'Adresse de livraison (facultatif)',
    quoteName: 'Nom',
    quoteCompany: 'Entreprise',
    quoteStreet1: 'Rue ligne 1',
    quoteStreet2: 'Rue ligne 2',
    quotePostalCode: 'Code postal',
    quoteCity: 'Ville',
    quoteState: 'État / Région',
    quoteCancel: 'Annuler',
    quoteSend: 'Envoyer la demande',
    quoteSent: 'Demande de devis envoyée, merci.',
    quoteAlertEmail: 'Veuillez saisir une adresse e-mail valide.',
    quoteAlertCountry: 'Veuillez saisir votre pays.',
    quoteAlertError: 'Une erreur est survenue, veuillez réessayer.',
    quoteSelectedItems: 'Articles sélectionnés',

    // Background
    bgBasedIn: 'Basé à',
    bgCity: 'Bordeaux',
  },
  en: {
    // SplashScreen
    splashTitle: 'Please wait…',
    splashLoading: 'Creating user profile…',

    // WindowHome
    homeTitle: 'OnlineCreation.exe',
    homeHeadline: 'Is your website worthy of the year 2000?',
    homeDescription: 'supports you in the development or redesign of your web and mobile projects:',
    homeWebsite: 'website',
    homeMobileApp: 'iOS and Android mobile app',
    homeEcommerce: 'e-commerce',
    homeContact: 'Contact',
    homeAbout: 'About',
    homePortfolio: 'View portfolio',

    // WindowContact
    contactTitle: 'contact2000.exe',
    contactMessageSent: 'Message sent, thank you.',
    contactIntro: 'Tell us about your project!',
    contactFormLabel: 'Contact form',
    contactName: 'Name',
    contactNamePlaceholder: 'John Doe',
    contactEmail: 'E-mail *',
    contactEmailPlaceholder: 'john.doe@aol.com',
    contactPhone: 'Phone',
    contactPhonePlaceholder: '+1 555 123 4567',
    contactSubject: 'Subject *',
    contactSubjectPlaceholder: 'Web development',
    contactMessageDefault: 'Hello,',
    contactRequired: '* Required fields',
    contactCancel: 'Cancel',
    contactSend: 'Send',
    contactConfirmQuit: 'Do you really want to quit?',
    contactQuitWithout: 'Quit without sending',
    contactDontQuit: 'Don\'t quit',
    contactAlertEmail: 'Please enter your e-mail address.',
    contactAlertMessage: 'Please enter your message (10 characters minimum)',
    contactAlertSubject: 'Please enter a subject.',
    contactAlertError: 'An error occurred, please try again.',

    // WindowAbout
    aboutTitle: 'About OnlineCreation',
    aboutDescription: 'OnlineCreation is the Bordeaux-based web agency that will support you in all your connected development projects.',
    aboutLocation: 'Location',
    aboutMapAlt: 'Based in Bordeaux',
    aboutHQ: 'Headquarters',
    aboutCapital: 'SARL with a capital of €4,500',
    aboutSiret: 'SIRET',
    aboutTVA: 'VAT number',
    aboutDirector: 'Publication dir.',
    aboutHost: 'Host',
    aboutServices: 'Services',
    aboutServiceWeb: '<strong>Website</strong> creation',
    aboutServiceShop: 'Online <strong>shops</strong>',
    aboutServiceApp: '<strong>Application</strong> design',
    aboutServiceDesign: '<strong>Graphic</strong> UI/UX web design',
    aboutServiceMaintenance: 'Web project <strong>maintenance</strong>',
    aboutTech: 'Technologies',
    aboutCredits: 'Credits',
    aboutCreditsText: 'Website built with',
    aboutClose: 'Close',
    aboutContactBtn: 'Contact OnlineCreation',

    // WindowPortfolio
    portfolioTitle: 'portfolio.exe',
    portfolioClient: 'Client',
    portfolioProject: 'Project',
    portfolioClose: 'Close',
    portfolioContactBtn: 'Contact OnlineCreation',

    // WindowSite
    sitePreview: 'Preview',
    siteVisit: 'Visit website',
    siteNeed: 'Need',
    siteSolution: 'Solution provided by OnlineCreation',
    siteTech: 'Technologies',
    siteClose: 'Close',
    siteContactBtn: 'Contact OnlineCreation',

    // WindowSettings
    settingsTitle: 'Settings',
    settingsWallpaper: 'Wallpaper',
    settingsWallpaperParticles: 'Particles (default)',
    settingsWallpaperTeal: 'Solid color (Teal)',
    settingsWallpaperPhoto: 'Photo (Landscape)',
    settingsPreview: 'Preview',
    settingsLanguage: 'Language',
    settingsLangFr: 'Français',
    settingsLangEn: 'English',
    settingsApply: 'Apply',
    settingsClose: 'Close',

    // Taskbar
    taskbarClose: 'Close',

    // Desktop icons
    iconOnlineCreation: 'OnlineCreation.exe',
    iconContact: 'contact2000.exe',
    iconShop: 'shop.exe',

    // WindowShop
    shopTitle: 'shop.exe',
    shopLoading: 'Loading catalog\u2026',
    shopError: 'Error loading catalog.',
    shopRetry: 'Retry',
    shopEmpty: 'No results.',
    shopFilters: 'Filters',
    shopColumns: 'Columns',
    shopBrand: 'Brand',
    shopModel: 'Model',
    shopScreen: 'Screen',
    shopRam: 'RAM',
    shopStorage: 'Storage',
    shopGrade: 'Grade',
    shopColor: 'Color',
    shopCpu: 'CPU',
    shopBattery: 'Battery',
    shopGpu: 'GPU',
    shopOs: 'System',
    shopStock: 'Stock',
    shopInStock: 'In stock',
    shopPrice: 'Price (incl. tax)',
    shopPriceHt: 'Price (excl. tax)',
    shopEcotax: 'incl. eco-contribution',
    shopQuoteBtn: 'Request a quote',
    shopFilterAll: 'All',
    shopNoSelection: 'Please select at least one item.',
    shopClose: 'Close',

    // WindowQuote
    quoteTitle: 'quote.exe',
    quoteIntro: 'Request a quote for the selected items.',
    quoteContactInfo: 'Contact information',
    quoteEmail: 'E-mail *',
    quoteEmailPlaceholder: 'your@email.com',
    quoteCountry: 'Country *',
    quoteCountryPlaceholder: 'France',
    quoteShippingLabel: 'Shipping address (optional)',
    quoteName: 'Name',
    quoteCompany: 'Company',
    quoteStreet1: 'Street line 1',
    quoteStreet2: 'Street line 2',
    quotePostalCode: 'Postal code',
    quoteCity: 'City',
    quoteState: 'State / Region',
    quoteCancel: 'Cancel',
    quoteSend: 'Send request',
    quoteSent: 'Quote request sent, thank you.',
    quoteAlertEmail: 'Please enter a valid e-mail address.',
    quoteAlertCountry: 'Please enter your country.',
    quoteAlertError: 'An error occurred, please try again.',
    quoteSelectedItems: 'Selected items',

    // Background
    bgBasedIn: 'Based in',
    bgCity: 'Bordeaux',
  }
}

function detectLanguage() {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en'
  return browserLang.startsWith('fr') ? 'fr' : 'en'
}

export function t(key, lang) {
  const currentLang = lang || detectLanguage()
  return translations[currentLang]?.[key] || translations['en']?.[key] || key
}

const portfolioEn = {
  14: {
    brief: 'Automated scientific website administration',
    need: 'Several research units affiliated with Bordeaux Neurocampus, a neuroscience structure at the University of Bordeaux, needed websites to showcase their activities. However, these units lacked the time to manage and update these sites.',
    solution: 'In cooperation with Bordeaux Neurocampus, OnlineCreation developed a tool to automatically generate and maintain websites for research units. Each site is based on a common template but can be customized with the unit\'s logo, colors, and specific content. Scientific teams can focus on their research while Bordeaux Neurocampus helps them maintain dynamic, up-to-date sites and OnlineCreation handles the overall technical maintenance.',
  },
  13: {
    brief: 'Local and 100% plant-based market in Bordeaux',
    need: 'Green Market is a traveling market that showcases talented artisans and producers working exclusively with plant-based products, in various neighborhoods of Bordeaux and its metropolitan area. The previous website, designed and maintained on a volunteer basis, relied on tools that had become too complex to maintain and could not be taken over by the current team.',
    solution: 'OnlineCreation built a new, simple yet effective website with a streamlined administration interface. Content creation was reduced to filling out a simple form, and everything that can be automated is. OnlineCreation supports the Green Market team with updates and technical maintenance of their site.',
  },
  12: {
    brief: 'European research project in personalized medicine',
    need: 'The BOTS project (Blue Organoid for Treatment Selection) is a European project funded by the Interreg Atlantic Area program. It brings together research teams from five universities across four countries to develop personalized medicine technologies. BOTS needed a logo and a website to communicate about its progress.',
    solution: 'OnlineCreation studied the context of the BOTS project to design a logo evoking biology and the ocean, then created a multilingual website (French, English, Spanish, Portuguese) to present the project, its progress, and its partners. The site is built with WordPress for easy updates by the project teams.',
  },
  11: {
    brief: 'Manufacturer of Renault and Dacia car key shells',
    need: 'LM Parts was launching its 100% made-in-France automotive accessories business. To start selling online without stretching its initial budget, the startup needed an affordable French solution.',
    solution: 'OnlineCreation proposed a turnkey solution in the form of a single-page e-commerce website: simple, elegant, and easy to use and maintain thanks to OnlineCreation.me.',
  },
  10: {
    brief: 'Researcher association web portal',
    need: 'Redesigning an existing website with modern technologies while maintaining a connection with a legacy 4D database.',
    solution: 'OnlineCreation brought the power of WordPress, into which we integrated the legacy 4D applications and forms. Additionally, easy-to-use <i>no-code</i> tools were deployed to make the site even more flexible and the client more autonomous.<br>A genuine trust relationship was built, with the development and maintenance of several websites, including the <a href="https://www.semaineducerveau.fr" target="_blank" rel="noreferrer">Brain Awareness Week</a>, the national science outreach event.',
  },
  9: {
    brief: 'Website for a stone landscaping artisan',
    need: 'With an aging website, Cédric Farrusseng struggled to truly convey the spirit of his craft: working with noble stones to create sublime furniture.',
    solution: 'OnlineCreation reimagined web standards to maximize the value of Cédric Farrusseng\'s work, to the point of making visitors forget they\'re on a website. Everything was designed to make technology so effective it disappears: full-screen photos, adaptive framing for any screen type, minimalist layout to maximize space for the showcased work…',
  },
  8: {
    brief: 'Website for the Bordeaux Institute of Oncology Research',
    need: 'All oncology research teams at the University of Bordeaux united to create a single institute, BRIC. Its first mission: showcasing the combined strength of this union on a web platform.',
    solution: 'OnlineCreation designed a bilingual website highlighting the 11 research teams equipped with the latest scientific imaging innovations. Administrative staff were guided toward maximum autonomy in managing the site.<br>A tool was developed to allow team leaders to write their own dedicated pages, featuring their latest scientific publications (directly extracted from PubMed), current research themes, and their team.',
  },
  7: {
    brief: 'Website for a wealth management firm',
    need: 'This newly established wealth management firm had the excellent reflex of contacting OnlineCreation to establish a web presence as soon as possible, on a very tight budget, without sacrificing aesthetics or functionality.',
    solution: 'Leveraging OnlineCreation.me technology, we designed and built a single-page showcase website in record time. With a clean and effective design, and thanks to the power of OnlineCreation.me, costs were compressed to the extreme. The client was able to focus on their business and building their client base.',
  },
  6: {
    brief: 'Japanese learning application',
    need: 'Japan is a dream destination. To make the most of a visit, being able to decipher some Japanese characters is essential. The problem: true mastery is impossible for a foreigner without dedicating several years.',
    solution: 'We developed a solution capable of maximizing the learning curve by focusing on the most effective aspect: the Katakana syllabary, used to transcribe foreign words.<br>In just two hours, you will effortlessly master 20% of Japanese vocabulary!',
  },
  5: {
    brief: 'Website creation platform',
    need: 'In 2006, building a website required either being a development expert or being ready to pay a small fortune to a web agency. All existing solutions presented financial or technical barriers.',
    solution: 'We designed OnlineCreation.me to eliminate as many barriers as possible in website creation. The technical barrier was removed — webmasters enter their content as simply as writing an email. The financial barrier was eliminated, with pricing starting at €15 per year for a showcase site including hosting, thanks to maximum automation.',
  },
  4: {
    brief: 'Puzzle game inspired by 2048',
    need: 'In 2014, everyone was playing <a href="https://play2048.co/" target="_blank" rel="noreferer">2048</a>. The problem was that after a few games, it became way too easy!',
    solution: 'We designed Z to spice up this puzzle game.<br/>Rather than combining numbers, you combine letters. Combine two A\'s to get a B, two C\'s to get a D, and so on. With a 25-cell grid, it\'s theoretically possible to reach the letter Z, the game\'s ultimate goal.<br>The game is harder, but also terribly addictive! No one has reached Z to this day. Could you be the first? Don\'t forget to let us know!',
  },
  1: {
    brief: 'Scannable code generator',
    need: 'Bridging the physical and digital worlds is a major challenge. QR codes are a simple and effective way to transport a prospect to a web resource, but generating them can sometimes be complicated.',
    solution: 'The QRCode Factory is an online QR code generator that creates scannable codes for smartphones. Simply enter the web page address where users should land and download the generated QR code. The code can be customized: style, color, and logo integration. The QRCode Factory is available in French, English, and Japanese.',
  },
};

export function pt(site, field, lang) {
  if (lang !== 'fr' && portfolioEn[site.id]?.[field]) {
    return portfolioEn[site.id][field];
  }
  return site[field];
}

export { translations, detectLanguage }
